import Vue from "vue";
import {BootstrapVue, IconsPlugin, BPagination} from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import DatePicker from 'vue2-datepicker';
import {VueSignaturePad} from 'vue-signature-pad';
import moment from 'moment';
import 'moment/locale/es';
import VueMoment from 'vue-moment';
Vue.use(VueMoment, { moment });
Vue.use(BootstrapVue, IconsPlugin, BPagination, DatePicker, VueSignaturePad);

require('./bootstrap');

window.Vue = require('vue');

Vue.component('attended-by', require('./components/attended-by/attended-by.vue').default);
Vue.component('checkout', require('./components/checkout/checkout.vue').default);
Vue.component('crud-estado', require('./components/rel-edo-cd/estado.vue').default);
Vue.component('crud-kind-file', require('./components/kind-file-stationery/kindFile.vue').default);
Vue.component('crud-ciudad', require('./components/rel-edo-cd/ciudades.vue').default);
Vue.component('crud-packages', require('./components/packages/list.vue').default);
Vue.component('crud-rel-serv-pack', require('./components/packages/rel-serv-pack.vue').default);
Vue.component('crud-services', require('./components/services/services.vue').default);
Vue.component('crud-plans', require('./components/plans/plans.vue').default);
Vue.component('crud-rel-serv-plans', require('./components/plans/rel-serv-plans.vue').default);
Vue.component('crud-specialtys', require('./components/specialtys/specialtys.vue').default);
Vue.component('crud-rel-consultations-specialtys', require('./components/specialtys/rel-consultations-specialtys').default);
Vue.component('crud-supplier-ambulances', require('./components/suppliers/ambulances.vue').default);
Vue.component('crud-supplier-dentists', require('./components/suppliers/dentists.vue').default);
Vue.component('crud-supplier-radiology', require('./components/suppliers/radiology.vue').default);
Vue.component('crud-supplier-institutions', require('./components/suppliers/institutions.vue').default);
Vue.component('crud-supplier-laboratories', require('./components/suppliers/laboratories.vue').default);
Vue.component('crud-supplier-opticans', require('./components/suppliers/opticians.vue').default);
Vue.component('crud-supplier-specialist', require('./components/suppliers/specialist.vue').default);
Vue.component('crud-services-lab-hosp', require('./components/services-lab-hosp/services-lab-hosp.vue').default);
Vue.component('crud-payment-plan', require('./components/payment-plan/payment-plan').default);
Vue.component('crud-agents', require('./components/users/agents.vue').default);
Vue.component('crud-promoters', require('./components/users/promoters.vue').default);
Vue.component('crud-clients', require('./components/users/clients.vue').default);
Vue.component('crud-clients-canceled', require('./components/users/clients_canceled.vue').default);
Vue.component('crud-affiliates-titulars', require('./components/users/affiliate_titular.vue').default);
Vue.component('crud-affiliates-titulars-canceled', require('./components/users/affiliate_titulars_canceled.vue').default);
Vue.component('crud-affiliates-dependents', require('./components/users/affiliate_dependent.vue').default);
Vue.component('crud-quoter', require('./components/quoter/quoter.vue').default);
Vue.component('crud-quoter-worker', require('./components/quoter/quoter-workers.vue').default);
Vue.component('crud-admin', require('./components/users/admin.vue').default);
Vue.component('crud-category-laboratory', require('./components/catalog-laboratories/category-list.vue').default);
Vue.component('crud-catalog-list', require('./components/catalog-laboratories/catalog-list.vue').default);
Vue.component('commissions', require('./components/commissions/commissions.vue').default);
Vue.component('error-checkout', require('./components/checkout/error.vue').default);
Vue.component('invoice-list-and-upload', require('./components/Invoice-list-and-upload/invoice-list-and-upload.vue').default);
Vue.component('load-subsidiary-file', require('./components/import-file/load-subsidiary-file.vue').default);
Vue.component('load-affiliate-file', require('./components/import-file/load-afilliate-file.vue').default);
Vue.component('load-sinester-file', require('./components/import-sinester/load-sinester-file.vue').default);
Vue.component('load-catalog-file', require('./components/catalog-laboratories/load-catalog-file.vue').default);
Vue.component('list-sinister-provider', require('./components/sinister/list-sinisters-provider.vue').default);
Vue.component('legal-terms', require('./components/legal/legal.vue').default);
Vue.component('notifications', require('./components/notifications/notifications.vue').default);
Vue.component('place-of-care', require('./components/place-of-care/place-of-care.vue').default);
Vue.component('reason-for-attention', require('./components/reason-for-attention/reason-for-attention.vue').default);
Vue.component('refund-admin', require('./components/refund/refund-admin.vue').default);
Vue.component('refund-affiliate', require('./components/refund/refund.vue').default);
Vue.component('report-promoter-agent', require('./components/reports/promoter-agent.vue').default);
Vue.component('report-clients', require('./components/reports/report-clients.vue').default);
Vue.component('report-sinister', require('./components/reports/report-sinister.vue').default);
Vue.component('report-history-xls', require('./components/reports/report-history-xls.vue').default);
Vue.component('control-consulta', require('./components/sinister/control-consulta.vue').default);
Vue.component('upload-invoice', require('./components/invoices/invoices.vue').default);

//WIDGETS
//Vue.component('add-user-clients', require('./components/widgets/add_users_client.vue').default);
Vue.component('spinner', require('./components/widgets/spinner.vue').default);
Vue.component('print-card', require('./components/widgets/print-card.vue').default);
Vue.component('modal-notes', require('./components/widgets/modal-notes.vue').default);
Vue.component('modal-stationery', require('./components/widgets/stationery.vue').default);
Vue.component('modal-agents-for-promoter', require('./components/widgets/modal-agents-for-promoter.vue').default);
Vue.component('modal-monthly-payments', require('./components/widgets/modal-monthly-payments.vue').default);
Vue.component('modal-sinisters-list', require('./components/widgets/modal-sinisters-list.vue').default);
Vue.component('membresias', require('./components/widgets/membresia.vue').default);
Vue.component('invoice-ticket', require('./components/widgets/invoice-ticket.vue').default);
Vue.component('ticket-quoter-client', require('./components/widgets/ticket_quoter_client.vue').default);
Vue.component('ticket-quoter-workers-client', require('./components/widgets/ticket_quoter_workers_client.vue').default);
Vue.component('ticket-comission-quoter', require('./components/widgets/ticket_comission_quoter.vue').default);
Vue.component('upload-subsidiary', require('./components/widgets/subsidiary.vue').default);
Vue.component('modal-services-supplier', require('./components/widgets/rel-serv-supplier.vue').default);
Vue.component('sinisters-providers-admin', require('./components/sinister/sinisters-providers-admin.vue').default);
Vue.component('sinisters-specialists-admin', require('./components/sinister/sinisters-specialists-admin.vue').default);
Vue.component('sinesters-clients-component', require('./components/widgets/sinesters-clients.vue').default);
Vue.component('sinisters-specialists', require('./components/widgets/sinisters-specialists.vue').default);
Vue.component('ticket-refund', require('./components/widgets/ticket-refund.vue').default);
Vue.component('history-account-status', require('./components/widgets/history-account-status.vue').default);
Vue.component('history-account-status-provider', require('./components/widgets/history-account-status-provider.vue').default);
Vue.component('history-quoting-promoter', require('./components/widgets/history-quoting-promoter.vue').default);
Vue.component('history-trashed-clients', require('./components/widgets/history-trashed-clients.vue').default);
Vue.component('complement-invoice', require('./components/widgets/complement-invoice.vue').default);
Vue.component('update-info-bank-affiliate', require('./components/widgets/updateInfoBankAffiliate.vue').default);

//HISTORY SON PARA EL CLIENTE
Vue.component('history-quoting-client', require('./components/widgets/history-quoting-client.vue').default);
Vue.component('history-affiliate', require('./components/widgets/history-affiliate-titular.vue').default);
Vue.component('history-sinister-affiliate', require('./components/widgets/history-sinister-affiliate.vue').default);

//GRAFICAS
Vue.component('quoter-by-agent', require('./components/widgets/reports/quoter-by-agent.vue').default);

const app = new Vue({
    el: '#app',
});

//let tabLi = document.querySelectorAll(".tabMenu li");
let _tabLi = $(".tabMenu li a");
let _tabs = $("#tabs");
let _outerLoader = $('.outer-loader');
//DETECT THE RESOLUTION OF WINDOW
let width = $(window).width();

$(window).ready(function () {
    if (_outerLoader.length > 0) {
        _outerLoader.delay(1000).fadeOut('slow');
    }
    //MENU RESPONSIVE JS

    //IF THE RESOLUTION IS LESS THAN 768PX
    if (width <= 1024) {

        window.addEventListener("DOMContentLoaded", function () {

            let menuItems = document.querySelectorAll("#mainMenu .nav-item");

            menuItems.forEach(function (item) {
                let link = item.querySelector("a.has-arrow");
                let subMenuLvOne = item.querySelector(".subMenuLvOne");

                if (link) {
                    link.addEventListener("click", function (e) {
                        e.preventDefault();
                        console.log('click-menu');
                        // Cerrar otros submenús LvOne
                        closeOtherSubMenus(item);
                        // Cerrar .scroll-content
                        //document.querySelector('.scroll-content').style.display = 'none';

                        //subMenuLvOne.classList.toggle("active");
                        subMenuLvOne.style.display = (subMenuLvOne.style.display === 'none' || subMenuLvOne.style.display === '') ? 'block' : 'none';
                    });
                }

                let subMenuLv2Items = item.querySelectorAll(".subMenuLv2 .nav-item");

                subMenuLv2Items.forEach(function (subItem) {
                    let subLink = subItem.querySelector("a.has-arrow");
                    let subMenuLv2 = subItem.querySelector(".subMenuLv2");

                    if (subLink) {
                        subLink.addEventListener("click", function (e) {
                            e.preventDefault();

                            // Cerrar otros submenús Lv2
                            closeOtherSubMenus(subItem);
                            // Cerrar .scroll-content
                            //document.querySelector('.scroll-content').style.display = 'none';

                            //subMenuLv2.classList.toggle("active");
                            subMenuLv2.style.display = (subMenuLv2.style.display === 'none' || subMenuLv2.style.display === '') ? 'block' : 'none';
                        });
                    }
                });
            });

            function closeOtherSubMenus(currentItem) {
                menuItems.forEach(function (item) {
                    if (item !== currentItem) {
                        let otherSubMenuLvOne = item.querySelector(".subMenuLvOne");
                        let otherSubMenuLv2 = item.querySelector(".subMenuLv2");

                        if (otherSubMenuLvOne) {
                            //otherSubMenuLvOne.classList.remove("active");
                            otherSubMenuLvOne.style.display = 'none';
                        }

                        if (otherSubMenuLv2) {
                            //otherSubMenuLv2.classList.remove("active");
                            otherSubMenuLv2.style.display = 'none';
                        }
                    }
                });
            }

        });
    }

});

$(document).ready(function () {

    $('.btnBar a').on('click', function () {
        $('.scroll-content').toggle('slow');
    });

    //MENU DE LOS DASHBOARDS
    if (_tabLi.length > 0) {

        let currentClass = 'dashboard';

        _tabLi.on('click', function () {

            if ($(this).attr('class') !== 'has-arrow') {
                console.log('clicking = ' + $(this).attr('class'));

                if (currentClass !== $(this).attr('class') && currentClass !== '') {
                    _tabs.find('.' + currentClass).removeClass('active');
                }

                currentClass = $(this).attr('class');

                _tabs.find('.' + currentClass).addClass('active');
                if (width <= 1024) {
                    document.querySelector('.scroll-content').style.display = 'none';
                }
            }

        });

    }

})

